import React from 'react';
import PropTypes from 'prop-types';

const FormattedNumber = ({
  children = /** @type {number|string|undefined} */ (undefined),
  unit = /** @type {string|null} */ (null),
  roundedTo = /** @type {number|undefined} */ (undefined)
}) => {
  const { format } = Intl.NumberFormat('en-US', {
    minimumFractionDigits: roundedTo,
    maximumFractionDigits: roundedTo,
    ...(unit === 'usCurrency'
      ? {
          style: 'currency',
          currency: 'USD'
        }
      : {})
  });
  return (
    <>
      {format(children)}
      {unit === 'bu' && ' bu'}
    </>
  );
};

FormattedNumber.propTypes = {
  children: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  unit: PropTypes.oneOf(['bu', 'usCurrency']),
  roundedTo: PropTypes.number
};

export default FormattedNumber;
